export const cls = (obj: Record<string, boolean | undefined>) => {
  return Object.keys(obj)
    .filter((key) => obj[key])
    .join(" ");
};

export const join = (...key: (string | undefined)[]) => {
  return key.join(" ");
};
